export const DISABLE_NOTIFICATION = [
  '/register/validate-token',
  '/here/validate-address',
  '/general',
];
